import React from 'react'
import AdmCircularEntry from '../../components/AdminTabs/AdminCircularEntry/AdmCircularEntry'

const CircularEntry = () => {
  return (
    <div>
      <AdmCircularEntry />
    </div>
  )
}

export default CircularEntry
